"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrossellModuleBase = void 0;
const react_1 = require("react");
const features_1 = require("../../features");
const useCrossellModuleBase = (API, tracker, crossellDataParams, crossellConfig = {}) => {
    const [crossellListCards, setCrossellListCards] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    function trackCrossellModuleView(data) {
        data?.forEach((item, index) => tracker?.track(features_1.crossellModuleTrackingActions.CROSSELL_MODULE_VIEW, { item, index }));
    }
    function getCrossellListCards() {
        return (0, features_1.fetchCrossellModule)(API, crossellDataParams, tracker, crossellConfig)
            .then(data => {
            setCrossellListCards(data);
            trackCrossellModuleView(data);
        })
            .catch(() => setHasError(true))
            .finally(() => setIsLoading(false));
    }
    (0, react_1.useEffect)(() => {
        getCrossellListCards();
    }, []);
    return {
        crossellModuleTitle: 'mbCrossellModule.title',
        crossellListCards,
        isLoading,
        hasError,
    };
};
exports.useCrossellModuleBase = useCrossellModuleBase;
exports.default = exports.useCrossellModuleBase;
//# sourceMappingURL=useCrossellModuleBase.hook.js.map